import axios from "axios";

export default axios.create({
  baseURL: "https://nzvedaz-bft.herokuapp.com",
});
